import React from "react";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useParams } from "react-router-dom";
import { Container, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  useGetOneGroupQuery,
  useUpdateGroupMutation,
} from "../../../services/groups";
import GroupForm from "../GroupForm";
import PermissionGate from "../../../CommonElements/PermissionGate";
import { USER_MANAGEMENT_PERMISSIONS } from "@/utils/constants";

const UpdateGroup = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { data: groupDataRes, isLoading: isLoadingGroup } =
    useGetOneGroupQuery(id);
  // Show loading spinner while fetching group data

  const { permissions, ...groupData } = groupDataRes?.data?.data ?? {
    name: undefined,
    system_id: undefined,
    permissions: [],
  };
  if (isLoadingGroup) {
    return (
      <Container fluid>
        <PageHeader
          title={t("UPDATE_GROUP")}

        />

        <div className="d-flex justify-content-center align-items-center mt-5">
          <Spinner color="primary" />
          <span className="ms-2">{t("LOADING")}</span>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid>
      <PageHeader
        title={t("UPDATE_GROUP")}

      />

      <GroupForm
        initialData={{
          ...groupData,
          permissions: permissions.map((permission) => permission?.id),
        }}
        mutation={useUpdateGroupMutation}
        submitButtonText={t("UPDATE_GROUP")}
      />
    </Container>
  );
};

export default UpdateGroup;
